import dayjs from 'dayjs'

export const CREATE_SCENARIO_ROUTE_ID = 'creating-new-scenario'
export const CREATE_SCENARIO_ACTION_ROUTE_ID = 'creating-new-action'
export const scenarioConditionPlaceholder = `Examples: 
If the user would like to get their account balance
If the user would like to book an appointment`
export const scenarioInstructionsPlaceholder = `Examples: 
1. Ask for their email address if you don’t already have it from the conversation. 
2. Run the get_customer_id function...
3. Ask for their birthday to confirm...`
export const DEFAULT_SCENARIO_NAME = `Scenario ${dayjs().format('MMMM D, YYYY')}`
export const DEFAULT_SCENARIO_ACTION_NAME_PLACEHOLDER = `Example: get_appointment_availability`
export const ACTION_DESCRIPTION_PLACEHOLDER =
  'Enter a description to provide helpful details about when and how to use this action.'
export const ACTION_WEBHOOK_PLACEHOLDER =
  'https://www.webhook.com/get_availability'
export const ACTION_WAIT_MESSAGE_PLACEHOLDER =
  'e.g. “Hold on while we find available appointments.”'

export const SCENARIO_BUILDER_URL = 'https://help.heylibby.ai/scenario-builder'

export const OAUTH_CONNECTION_MESSAGE_TYPE = 'oauth-connection-result'
